export default "__VITE_ASSET__DW_2nikw__"